import { Entry } from "./components/entry";
import { Base } from "./label.base";

export const Label = Object.assign(Base, {
    Entry: Entry
});
